/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation, untranslated } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import { useEffect, useRef, useState, type ChangeEvent } from "react";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants";
import { statusCategories } from "@Features/portal-settings";
import { useDispatch, useSelector } from "react-redux";
import {
  changeResourceStatusInReview,
  fetchBulkTransitionStatusList,
  fetchListOfStatusesAvailable,
  getStatusBtnStyle,
} from "./ReviewsHelper";
import Signature from "@Components/Signature";
import CheckBoxComponent from "@CubeComponents/Mui_Form/CheckBox";
import UserNameTagComponent from "@CubeComponents/html/UserNameTagComponent";
import { SignTypeValues } from "@CubeComponents/constants";
import { RootState } from "@Reducers/index";

function ChangeFileStatusModal({
  reviewId,
  statusTo,
  closeModal,
  statusFrom,
  resources,
  type,
  requireMandatoryComment = false,
  successMessage,
}: any) {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.userDetails);

  const dispatch = useDispatch();
  const _statusToRef = useRef<any>(null);

  const statusFromStyle = statusFrom?._id ? getStatusBtnStyle(statusFrom.category) : { backgroundColor: "#ecf3fe" };
  const defaultBackground =
    type === "standardTransition"
      ? statusCategories.find((record: any) => record.name === statusTo.category)
      : statusCategories.find((record: any) => record.name === null);

  const defaultSignatureModalData = {
    comment: "",
    statusTo: {
      ...statusTo,
      background: defaultBackground?.background,
    },
    signType: SignTypeValues.DRAW_ON_SCREEN,
    signDoc: null,
  };

  const handleCheckboxClick = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setShowSignature(checked);
  };

  const [statusList, setStatusList] = useState<any[]>([]);
  const [modalData, setModalData] = useState(defaultSignatureModalData);
  const [showSignature, setShowSignature] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isLoadingForChangeStatus, setIsLoadingForChangeStatus] = useState(false);

  const confirmHandler = async () => {
    const { comment, statusTo, signDoc } = modalData;
    setIsLoadingForChangeStatus(true);
    const data = {
      comment,
      statusTo: statusTo._id,
      reviewId,
      resources,
      ...(showSignature && signDoc ? { signature: signDoc } : {}),
      ...(showSignature && !signDoc ? { signatureId: user.signature } : {}),
    };

    const response = await changeResourceStatusInReview(data);
    setIsLoadingForChangeStatus(false);

    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: successMessage ?? t("File(s) status updated successfully"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      closeModal(true);
      return;
    }

    const content = response.data.errorMessage
      ? untranslated(response.data.errorMessage)
      : untranslated("The resource status could not be updated");

    dispatch(showToastNotification({ content, type: TOAST_TYPE_ERROR }));
    closeModal();
  };

  const getDropdownBackground = (category: any) => {
    const matchedCategory = statusCategories.find((record: any) => record.name === category);
    const background = matchedCategory ? matchedCategory.background : BUTTON_TYPES.DROPDOWN_BACKGROUND_ROYAL_BLUE_LIST;

    return background;
  };

  const commentHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setModalData((prev) => ({ ...prev, comment: e.target.value }));
  };

  const handleSignDocChange = async (e: any) => {
    if (e === SignTypeValues.IMPORT_PROFILE_SIGNATURE) {
      if (user.signature) {
        setIsButtonEnabled(true);
      }
    }
    setModalData((prev) => ({ ...prev, signDoc: e.base64ImageStr }));
  };

  const statusToChangeHandler = (newValue: any) => {
    if (!newValue) return;
    const { category } = newValue;
    const background = getDropdownBackground(category);
    setModalData((prev) => ({
      ...prev,
      statusTo: { _id: newValue._id, background, ...newValue },
    }));
  };

  function getDropdownCategoryStyles(category: any) {
    if (category === null) {
      return { backgroundColor: "#ecf3fe" };
    }

    const matchedCategory = statusCategories.find((record: any) => record.name === category);
    const backgroundColor = matchedCategory ? matchedCategory.backgroundHexcode : "#0006A2";

    const style = { backgroundColor };
    return style;
  }

  function _dropdownItemTemplate(args: any) {
    const style = getDropdownCategoryStyles(args.category);

    return (
      <div className="py-2 px-3">
        <span style={style} className="rounded py-1 px-4 text-sm text-white">
          {args.name}
        </span>
      </div>
    );
  }

  function _dropdownItemTemplateBulkTransition(args: any) {
    const style = getDropdownCategoryStyles(args.category);

    return (
      <div className="py-2 px-3">
        <span className="bg-[#f0f5f9] p-1 me-2 rounded">{args.count}</span>
        <span style={style} className="rounded py-1 px-4 text-sm text-white">
          {args.name}
        </span>
      </div>
    );
  }

  const fetchStatusListAvailable = async () => {
    const response = await fetchListOfStatusesAvailable({
      value: { params: { reviewId, resource: resources[0] } },
    });

    if (response.data.status) {
      const result = response.data.result;
      setStatusList(Array.isArray(result) ? result : []);
      return;
    }

    dispatch(
      showToastNotification({
        content: t("Internal Server Error"),
        type: TOAST_TYPE_ERROR,
      }),
    );
    closeModal();
  };

  const fetchStatusListForBulkTransition = async () => {
    const response = await fetchBulkTransitionStatusList({
      value: { params: { reviewId, resources } },
    });

    if (response.data.status) {
      const result = response.data.result;
      setStatusList(Array.isArray(result) ? result : []);
      return;
    }

    dispatch(
      showToastNotification({
        content: t("Internal Server Error"),
        type: TOAST_TYPE_ERROR,
      }),
    );
    closeModal();
  };

  useEffect(() => {
    if (type === "standardTransition") {
      fetchStatusListAvailable();
    }

    if (type === "bulkTransition") {
      fetchStatusListForBulkTransition();
    }
  }, []);

  const getUserAvatarComponent = (user: any) => <UserNameTagComponent id={user.id} />;

  const header = () => (
    <p className="font-[var(--font-weight-600)] text-2xl w-full rounded-t-1">{t("Change Status")}</p>
  );

  const content = () => (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <div className="flex flex-row items-center justify-between me-2">
          <span>{t("User")}</span>
          <div className="w-[27.875rem] flex self-start">{getUserAvatarComponent(user)}</div>
        </div>

        <div className="flex flex-row items-center justify-between me-2">
          <span>{t("Status")}</span>
          <div className="flex flex-row gap-4 items-center justify-between w-[27.875rem]">
            <div className="w-[12.5rem] min-w-0">
              <ToolTipComponent position="top" content={statusFrom?.name}>
                <div
                  className="h-8 rounded border-0 text-white font-[var(--font-weight-600)] flex items-center ps-2.5 text-sm overflow-hidden"
                  style={statusFromStyle}
                >
                  <span className="truncate">{statusFrom?.name}</span>
                </div>
              </ToolTipComponent>
            </div>

            <span>{t("to")}</span>

            <div className="w-[12.5rem]">
              {(() => {
                const selectedTo = statusList.find((s: any) => s._id === modalData.statusTo?._id) || null;
                return (
                  <AutoComplete
                    options={statusList}
                    valueField="_id"
                    openOnFocus
                    getOptionLabel={(option: any) => option?.name || ""}
                    value={selectedTo}
                    onChange={(_event: any, newValue: any) => statusToChangeHandler(newValue)}
                    renderOption={(props: any, option: any) => {
                      const style = getDropdownCategoryStyles(option.category);
                      return (
                        <li
                          {...props}
                          style={{ ...props.style, paddingInlineStart: "0.25rem", paddingInlineEnd: "0.25rem" }}
                        >
                          <div className="py-2 px-1 flex items-center">
                            {type === "bulkTransition" && (
                              <span className="bg-[#f0f5f9] p-1 me-2 rounded shrink-0">{option.count}</span>
                            )}
                            <span style={style} className="rounded py-1 px-4 text-sm text-white whitespace-nowrap">
                              {option.name}
                            </span>
                          </div>
                        </li>
                      );
                    }}
                    renderInput={(params: any) => {
                      if (selectedTo) {
                        const style = getDropdownCategoryStyles(selectedTo.category);
                        params.InputProps = {
                          ...params.InputProps,
                          startAdornment: (
                            <ToolTipComponent position="top" content={selectedTo.name}>
                              <span
                                style={style}
                                className="truncate rounded px-3 py-0.5 text-sm text-white max-w-full cursor-pointer"
                                onClick={(e) => {
                                  const input = e.currentTarget
                                    .closest(".MuiAutocomplete-root")
                                    ?.querySelector("input");
                                  if (input) {
                                    input.focus();
                                    input.dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));
                                  }
                                }}
                              >
                                {selectedTo.name}
                              </span>
                            </ToolTipComponent>
                          ),
                        };
                        params.inputProps = {
                          ...params.inputProps,
                          style: {
                            ...params.inputProps?.style,
                            opacity: 0,
                            width: 0,
                            minWidth: 0,
                            padding: 0,
                            position: "absolute",
                          },
                        };
                      }
                      return <TextFieldComponent {...params} />;
                    }}
                    slotProps={{ listbox: { sx: { maxHeight: "15.625rem", minWidth: "max-content" } } }}
                    sx={{ cursor: "pointer", "& .MuiInputBase-root": { cursor: "pointer" } }}
                  />
                );
              })()}
            </div>
          </div>
        </div>

        <div className="flex flex-row items-start justify-between me-2">
          {requireMandatoryComment ? <span>{t("Comment*")}</span> : <span>{t("Comment")}</span>}
          <div className="w-[27.875rem]">
            <TextFieldComponent
              placeholder={t("Enter Comments")}
              multiline
              rows={5}
              height="auto"
              value={modalData.comment}
              onChange={commentHandler}
            />
          </div>
        </div>

        <div>
          <CheckBoxComponent onChange={handleCheckboxClick} label="Add Signature" />
        </div>

        {showSignature && (
          <div className="flex flex-row items-start justify-between me-2 gap-24">
            <span>{t("Sign")}</span>
            <div className="w-[27.875rem]">
              <Signature
                onSuccess={(e) => handleSignDocChange(e)}
                dataSource={[
                  {
                    name: "Draw On Screen",
                    value: SignTypeValues.DRAW_ON_SCREEN,
                  },
                  {
                    name: "Attach Signed Document",
                    value: SignTypeValues.ATTACH_SIGNED_DOCUMENT,
                  },
                  {
                    name: "Add From Profile Settings",
                    value: SignTypeValues.IMPORT_PROFILE_SIGNATURE,
                  },
                ]}
                defaultSelectedSignType={SignTypeValues.DRAW_ON_SCREEN}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const footer = () => (
    <div className="flex gap-4">
      <ButtonComponent
        buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
        onClick={confirmHandler}
        disabled={
          (requireMandatoryComment && !modalData.comment.trim()) ||
          !modalData.statusTo?._id ||
          (!modalData.signDoc && showSignature && !isButtonEnabled)
        }
        loading={isLoadingForChangeStatus}
      >
        {t("Confirm")}
      </ButtonComponent>
      <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeModal}>
        {t("Cancel")}
      </ButtonComponent>
    </div>
  );

  return (
    <ModalStateDialogComponent
      allowModalPadding={false}
      headerTitle={header()}
      modelContent={content()}
      onCancel={closeModal}
      footerContent={footer()}
      isVisible
      width="42.5rem"
    />
  );
}
ChangeFileStatusModal.displayName = "ChangeFileStatusModal";
export default ChangeFileStatusModal;
